var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcCheckboxSelected(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 3,
    fill: "#00A656"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.1059 17C9.83913 17 9.58567 16.8884 9.39891 16.6931L5.62364 12.7447C5.23678 12.3401 5.23678 11.6704 5.62364 11.2658C6.0105 10.8612 6.65082 10.8612 7.03767 11.2658L10.1059 14.4747L16.9627 7.30345C17.3495 6.89885 17.9898 6.89885 18.3767 7.30345C18.7635 7.70806 18.7635 8.37775 18.3767 8.78235L10.8129 16.6931C10.6262 16.8884 10.3727 17 10.1059 17Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcCheckboxSelected);
export default __webpack_public_path__ + "static/media/IcCheckboxSelected.6500e5bce40562e0cecca247ebf3c281.svg";
export { ForwardRef as ReactComponent };